import { useQuery } from '@tanstack/react-query';

import { getOfferByMerchantID } from 'apis/wolt-capital/api';

import { useIsWoltCapitalFeatureFlagEnabled } from './useIsWoltCapitalFeatureFlagEnabled';

export const useGetOfferByMerchantID = (merchantID: string, enabled = true) => {
  const { isWoltCapitaFeatureFlagEnabled } = useIsWoltCapitalFeatureFlagEnabled('merchant', merchantID);

  const {
    data: merchantsOffer,
    error: merchantsOfferError,
    isFetching: isLoadingMerchantsOffer,
  } = useQuery(
    [`/public/api/v1/merchants/${merchantID}/offer`],
    () => {
      return getOfferByMerchantID(merchantID);
    },
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: isWoltCapitaFeatureFlagEnabled && enabled,
    },
  );

  const merchantOfferCurrency = merchantsOffer?.currency;
  const merchantOfferAmount = merchantsOffer?.amount;
  const hasOngoingOffer = merchantsOffer?.state === 'AVAILABLE_OFFER';

  return {
    merchantsOffer,
    merchantsOfferError,
    isLoadingMerchantsOffer,
    merchantOfferAmount,
    merchantOfferCurrency,
    hasOngoingOffer,
    isWoltCapitaFeatureFlagEnabled,
  };
};
